/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_Pointtwo1Inputs */

const ja_home_agency_pointtwo1 = /** @type {(inputs: Home_Agency_Pointtwo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`そのインサイトを活用してゲーマーコミュニティ内のエンゲージメントを高めることに取り組んできました。`)
};

const en_home_agency_pointtwo1 = /** @type {(inputs: Home_Agency_Pointtwo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With the insights, the connections, and the authenticity gamers value, we reach gamers of all types.`)
};

/**
* | output |
* | --- |
* | "With the insights, the connections, and the authenticity gamers value, we reach gamers of all types." |
*
* @param {Home_Agency_Pointtwo1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_agency_pointtwo1 = /** @type {((inputs?: Home_Agency_Pointtwo1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_Pointtwo1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_pointtwo1(inputs)
	return en_home_agency_pointtwo1(inputs)
});
export { home_agency_pointtwo1 as "home_agency_pointTwo" }